<script setup>
import { onMounted, ref } from "vue";
import axios from 'axios';
// const modalActive = ref(false);
// const toggleModal = () =>{
//     modalActive.value = !modalActive.value;
// };

// import ArgonButton from "@/components/ArgonButton.vue";
// let sewaProfileModal;
const nurseryBatchBlockList = ref([]);
onMounted(() => {
    getBlockList();
    // sewaProfileModal = new Modal(document.getElementById('sewaProfileModal'));
});
let model = {
    nurseryBlock: {
        batchblockid:'',
        location:'',
        blockname:'',
    },
};

function getBlockList(){
    axios.get('nursery/listAllBatchBlockId')
        .then(res => {
            nurseryBatchBlockList.value = res.data.batchblockid;
        }).catch(function (error){
            
            console.log('Error',error.message);
        });
};
function addNurseryBlock(){
    axios.post('nursery/addNurseryBlock',model.nurseryBlock)
    .then(res => {
        alert(res.data.message);
        model.nurseryBlock = {
            blockname:'',
            batchblockid:'',
            location:''
        };
        getBlockList();
        emit('updateBatchBlockDLL');
    }).catch(function (error){
        if(error.response){
            if(error.response.status == 422){
                alert('Error: Block ID, Block Name and Location is required! ');
            }else alert(error.response.message);
        }else if(error.request){
            console.log(error.request);
        }else{
            console.log('Error',error.message);
        }
    });
};
const emit = defineEmits(['updateBatchBlockDLL']);
</script>
<template>
  <!-- Modal -->
  <div class="modal fade" id="NurseryBlockModal" tabindex="-1" aria-labelledby="NurseryBlock" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="NurseryBlock">New Block</h5>
          <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close">X</button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label text-danger">Block ID</label>
                <input class="form-control" v-model="model.nurseryBlock.batchblockid" id="input_batchblockid" type="text" placeholder="Block ID" />
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label text-danger">Block Name</label>
                <input class="form-control" v-model="model.nurseryBlock.blockname" id="input_blockname" type="text" placeholder="Name..." />
            </div>
            <div class="col-md-4">
                <label for="example-text-input" class="form-control-label text-danger">Location</label>
                <input class="form-control" v-model="model.nurseryBlock.location" id="input_location" type="text" placeholder="Location..." />
            </div>
            <div class="col-md-1">
                <label for="example-text-input" class="form-control-label">&nbsp;</label>
                <button type="button" class="btn btn-primary " @click="addNurseryBlock" >Add</button>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-md-12">
                <table class="table align-items-center mb-0">
                    <thead>
                        <td class="text-uppercase text-secondary text-sm font-weight-bolder">Block ID</td>
                        <td class="text-uppercase text-secondary text-sm font-weight-bolder">Block Name</td>
                        <td class="text-uppercase text-secondary text-sm font-weight-bolder">Location</td>
                        <td></td>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in nurseryBatchBlockList" :key="index">
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div class="d-flex flex-column justify-content-center">
                                        <h6 class="mb-0 text-sm">{{ item.batchblockid }}</h6>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <h6 class="text-xs font-weight-bold mb-0">{{ item.blockname }}</h6>
                            </td>
                            <td>
                                <h6 class="text-xs font-weight-bold mb-0">{{ item.location }}</h6>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>